<app-monitoring-tickets-osm-map [tickets]="tickets"></app-monitoring-tickets-osm-map>
